import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  Modal,
  CheckBox,
} from "react-native";
import { Picker } from "@react-native-picker/picker";
import { styles } from "../../style/FoundryStyle";
import { getCurrentDateTime } from "../../services/Functions";
import { useSelector, useDispatch } from "react-redux";
import {
  getListProblemSolution,
  InsertNewtimeMultiWork,
  setLog,
} from "../../services/ConnectDataBase.js";
import { LISTA_INCIDENCIAS, typeConnect } from "../../constants/Constants";
import { SCREEN_IDS } from "../FullComponent.js";
import { translateText } from "../../translations/translationService";
import { STATUS_COLORS, BACKGROUND_COLORS, TEXT_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

function NewCronometro({
  numPiezas,
  mo,
  proceso,
  currentScreenId,
  codProceso,
}) {
  const [listaProblemasSoluciones, setListaProblemasSoluciones] =
    useState(LISTA_INCIDENCIAS);
  const [cronometroFinalizado, setCronometroFinalizado] = useState(false);

  const [segundos, setSegundos] = useState(0);
  const [corriendo, setCorriendo] = useState(false);
  const name = useSelector((state) => state.user.name);
  const lang = useSelector((state) => state.lang.value);
  const team = useSelector((state) => state.user.team);
  const cod_team = useSelector((state) => state.user.cod_team);
  const [modalVisible, setModalVisible] = useState(false);
  const tipo_tiempo = "TIME_WORK";
  const [cantidad, setCantidad] = useState(parseFloat(mo.cantidad).toFixed(1));
  const [cantidadIncidencia, setCantidadIncidencia] = useState(0);
  const [fechaIni, setFechaIni] = useState(0);
  const [fechaFin, setFechaFin] = useState(0);

  const placeHolderFormatNumPiezas =
    "res: " +
    (parseFloat(numPiezas).toFixed(1) -
      parseFloat(mo.cantidad_terminada).toFixed(1));
  const piezasToWork =
    parseFloat(numPiezas).toFixed(1) -
    parseFloat(mo.cantidad_terminada).toFixed(1);
  const placeHolderIncidiencias = "Cantidad con incidencia";

  const [incidencia, setIncidencia] = useState(false);
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(""); // Estado para almacenar la opción seleccionada en el Picker

  const showValidationMessage = (message, type = "warn") => {
    notify[type]?.(message);
  };

  useEffect(() => {
    let interval;

    if (corriendo) {
      interval = setInterval(() => {
        setSegundos((prevSegundos) => prevSegundos + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [corriendo]);

  async function getListOptionsProblemQuality(mo) {
    try {
      const options = await getListProblemSolution(mo, 5, cod_team, "list");

      if (options != null) {
        setListaProblemasSoluciones(options);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleTime = async () => {
    aceptarCloseModal();
    const codigoIncidencia = LISTA_INCIDENCIAS.find(
      (item) => item.descripcion === opcionSeleccionada
    );

    await InsertNewtimeMultiWork(
      "PROCESOS",
      mo.po,
      mo.mo,
      name,
      team,
      fechaIni,
      fechaFin,
      proceso,
      tipo_tiempo,
      mo.cantidad,
      cantidad,
      cantidadIncidencia,
      typeConnect[1],
      currentScreenId,
      codProceso,
      codigoIncidencia ? codigoIncidencia.codigo : "",
      segundos
    );
    setCronometroFinalizado(true);
  };

  const aceptarCloseModal = () => {
    setModalVisible(false);
  };

  const denegarCloseModal = () => {
    setModalVisible(false);
  };

  const iniciarCronometro = () => {
    getListOptionsProblemQuality(mo);
    setSegundos(0);
    setCorriendo(true);
    setFechaIni(getCurrentDateTime());

    let tzoffset = new Date().getTimezoneOffset() * 60000; // Offset en milisegundos
    let localISOTime = new Date(Date.now() - tzoffset)
      .toISOString()
      .slice(0, -1);

    setLog(
      SCREEN_IDS.GENERAL,
      "LOG",
      "InicioTiempos",
      "Usuario: " +
        name +
        " Inicio: " +
        localISOTime +
        " Referencia: " +
        mo.mo +
        " Proceso: " +
        proceso
    );
  };

  const pausarCronometro = () => {
    setCorriendo(false);
  };

  const finalizarCronometro = () => {
    if (piezasToWork < cantidad) {
      showValidationMessage("La cantidad no puede superar el numero de piezas por terminar");
      return;
    } else {
      //setSegundos(0);
      setCorriendo(false);
      setFechaFin(getCurrentDateTime());
      setModalVisible(true);
    }
  };

  // Función para formatear los números a dos dígitos (agregar ceros a la izquierda)
  const formatearNumero = (numero) => {
    return numero < 10 ? `0${numero}` : numero;
  };

  const handleCantidadChange = (text) => {
    const cantidadFloat = parseFloat(text, 10);
    if (cantidadFloat > piezasToWork) {
      showValidationMessage("La cantidad no puede superar el número de piezas por terminar");
    } else {
      setCantidad(cantidadFloat);
    }
  };

  const handleCantidadIncidenciaChange = (text) => {
    const cantidadIncidenciaFloat = parseFloat(text, 10);
    if (cantidadIncidenciaFloat > cantidad) {
      showValidationMessage(
        "La cantidad de piezas con incidencia no puede ser mayor a la cantidad"
      );
    } else {
      setCantidadIncidencia(cantidadIncidenciaFloat);
    }
  };
  const modalFin = () => {
    return (
      <Modal visible={modalVisible} animationType='fade' transparent>
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>
              {translateText("Confirmar", lang)}
            </Text>
            <TextInput
              style={[styles.pickerItemStyle, { backgroundColor: "white" }]}
              placeholder={placeHolderFormatNumPiezas}
              placeholderTextColor='rgba(0, 0, 0, 0.4)' // Color de texto difuminado
              keyboardType='numeric'
              value={cantidad || ""} // Convierte la cantidad a cadena para mostrarla en el input
              onChangeText={handleCantidadChange}
            />
            <View style={styles.row}>
              <CheckBox
                style={[{ with: 15, margin: 5 }]}
                value={incidencia}
                onValueChange={(newValue) => setIncidencia(newValue)}
              />
              <Text style={styles.modalText}>Incidencia</Text>
            </View>
            {incidencia && ( // Mostrar el Picker solo cuando se marca la opción "Incidencia"
              <View>
                <TextInput
                  style={[styles.pickerItemStyle, { backgroundColor: "white" }]}
                  placeholder={placeHolderIncidiencias}
                  placeholderTextColor='rgba(0, 0, 0, 0.4)' // Color de texto difuminado
                  keyboardType='numeric'
                  value={cantidadIncidencia || ""} // Convierte la cantidad a cadena para mostrarla en el input
                  onChangeText={handleCantidadIncidenciaChange}
                />
                <Picker
                  style={styles.pickerItemStyle}
                  selectedValue={opcionSeleccionada}
                  onValueChange={(itemValue) =>
                    setOpcionSeleccionada(itemValue)
                  }>
                  {listaProblemasSoluciones
                    ? listaProblemasSoluciones.map((option, index) => (
                        <Picker.Item
                          key={option.codigo}
                          label={option.descripcion}
                        />
                      ))
                    : LISTA_INCIDENCIAS.map((option, index) => (
                        <Picker.Item
                          key={option.codigo}
                          label={translateText(option.descripcion, lang)}
                        />
                      ))}

                  {/* Agrega más opciones según tus necesidades */}
                </Picker>
              </View>
            )}
            <View style={styles.buttonModalContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonAccept]}
                onPress={handleTime}>
                <Text style={styles.modalText}>
                  {translateText("Aceptar", lang)}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonCancel]}
                onPress={denegarCloseModal}>
                <Text style={styles.modalText}>
                  {translateText("Cancelar", lang)}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    );
  };

  return (
    <View style={[{ textAlign: "center" }]}>
      {cronometroFinalizado ? (
        <Text style={styles.tableItemText}>
          {translateText("Finalizado", lang)}
        </Text>
      ) : (
        <Text
          style={{
            fontSize: 24,
            backgroundColor: BACKGROUND_COLORS.PRIMARY,
            color: "Black",
            borderRadius: 5,
          }}>
          {`${formatearNumero(Math.floor(segundos / 3600))}:${formatearNumero(
            Math.floor((segundos % 3600) / 60)
          )}:${formatearNumero(segundos % 60)}`}
        </Text>
      )}
      {cronometroFinalizado ? null : (
        <View style={[styles.row]}>
          {corriendo ? (
            <TouchableOpacity onPress={pausarCronometro}>
              <Text
                style={[
                   styles.buttonAddWeight,
                  {
                    fontSize: 16,
                    backgroundColor: STATUS_COLORS.WARNING,
                    height: 45,
                    width: 105,
                  color: TEXT_COLORS.LIGHT,
                    margin: 5,
                  },
                ]}>
                {translateText("Pausar", lang)}
              </Text>
            </TouchableOpacity>
          ) : (
            <TouchableOpacity onPress={iniciarCronometro}>
              <Text
                style={[
                   styles.buttonAddWeight,
                  {
                    fontSize: 16,
                    height: 45,
                    width: 105,
                    backgroundColor: STATUS_COLORS.SUCCESS,
                  color: TEXT_COLORS.LIGHT,
                    margin: 5,
                  },
                ]}>
                {translateText("Iniciar", lang)}
              </Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity onPress={finalizarCronometro}>
            <Text
              style={[
                 styles.buttonAddWeight,
                {
                  fontSize: 16,
                  height: 45,
                  width: 105,
                  backgroundColor: STATUS_COLORS.ERROR,
                  color: TEXT_COLORS.LIGHT,
                  margin: 5,
                },
              ]}>
              {translateText("Finalizar", lang)}
            </Text>
          </TouchableOpacity>
        </View>
      )}
      {modalVisible && <View>{modalFin()}</View>}

      {/* Mostrar el modal cuando modalVisible es verdadero */}
    </View>
  );
}

export default NewCronometro;
